import { useMediaQuery } from '@mui/material';
export const useSmMediaQuery = () => useMediaQuery('(max-width: 767px)', { noSsr: true }); // SM
export const useXlMediaQuery = () => useMediaQuery('(min-width: 1300px)', { noSsr: true }); // XL
export const underXlMediaQuery = () => useMediaQuery('(max-width: 991px)', { noSsr: true }); // SM & MD
